export const BolsaoIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill="#EAEFFF" />
    <path
      d="M12 7.125C12.3359 7.125 12.6484 7.21094 12.9375 7.38281C13.2266 7.54688 13.4531 7.77344 13.6172 8.0625C13.7891 8.35156 13.875 8.66406 13.875 9V9.375H15.7266L15.75 9.72656L16.1484 16.875H7.85156L8.25 9.72656L8.27344 9.375H10.125V9C10.125 8.66406 10.207 8.35156 10.3711 8.0625C10.543 7.77344 10.7734 7.54688 11.0625 7.38281C11.3516 7.21094 11.6641 7.125 12 7.125ZM12 7.875C11.6875 7.875 11.4219 7.98438 11.2031 8.20312C10.9844 8.42188 10.875 8.6875 10.875 9V9.375H13.125V9C13.125 8.6875 13.0156 8.42188 12.7969 8.20312C12.5781 7.98438 12.3125 7.875 12 7.875ZM8.97656 10.125L8.64844 16.125H15.3516L15.0234 10.125H13.875V11.25H13.125V10.125H10.875V11.25H10.125V10.125H8.97656Z"
      fill="#2D5BFF"
    />
  </svg>
);
